import React from "react";
import styles from "./Hero.module.css";
import ParticlesBg from "../Particles/Particles";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.hero}>
      <div className={styles.heroBg}></div>
      {/* <div className={styles.heroParticlesContainer}>
      </div> */}
      {/* <ParticlesBg id="hero-particles" className={styles.heroParticles} /> */}
      <ParticlesBg id="heroParticles" className={styles.particlesWrapper} />
      <div className={styles.containerSm}>
        <div className={styles.heroInner}>
          <div className={styles.heroCopy}>
            <h1 className={styles.heroTitle}>{t("title")}</h1>
            <p className={styles.heroParagraph}>{t("paragraph")}</p>
            {/* <div className={styles.heroCta}>
              <a className={styles.button} href="#">
                Get early access
              </a>
            </div> */}
          </div>
          <div className={styles.mockupContainer}>
            <div className={styles.mockupBg}>
              <img src="/images/iphone-hero-bg.svg" alt="iPhone illustration" />
            </div>
            <img
              className={styles.deviceMockup}
              src="/images/mainscreen.png"
              alt="iPhone Hero"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
